import Link from "next/link";
import React from "react";
import Image from "next/image";
import { CrossBlackIcon, LogoV2 } from "@/src/Asset";

const DiscoverMobileView = ({
  isDropdownOpen,
  setIsDropdownOpen,
  discoverItems,
  handleLinkClick,
}: any) => {
  const handleClose = () => {
    console.log("close");
    setIsDropdownOpen(false);
  };

  return (
    <div
      className={`fixed lg:hidden top-0 left-0 w-full h-1/2 md:h-full sm:h-full bg-white text-black transition-transform duration-300 transform z-50 ${
        isDropdownOpen
          ? "translate-y-0"
          : "md:-translate-y-full -translate-y-[1000px]"
      } lg:hidden`}
    >
      <div className="flex justify-between p-4">
        {/* <Link href={isStudyAbroad ? "/study-abroad" : "/"}> */}
        <Image
          src={LogoV2}
          alt="Collegehai logo"
          title="Collegehai logo"
          width={500}
          height={500}
          className={`w-32 lg:w-40 h-8 lg:h-14 object-cover mt-2 -ml-2 lg:ml-0`}
        />
        {/* </Link> */}
        <button onClick={handleClose} className="text-xl">
          <CrossBlackIcon className="scale-75" />
        </button>
      </div>
      <ul className="grid grid-cols-2 gap-x-4 gap-y-2 mt-3 px-4">
        {discoverItems?.map((item: any) => (
          <li
            key={item.label}
            className="flex items-center gap-2 pb-1 w-full hover:bg-gray-100 hover:rounded-lg border-b"
          >
            <Link href={item.link} onClick={handleLinkClick}>
              <div className="flex items-center gap-2">
                <Image
                  src={item.icon}
                  alt={`Explore ${item.label}`}
                  width={300}
                  height={300}
                  className="w-7 h-7 object-center object-fill"
                />
                <span className="font-medium text-sm text-primary">
                  {item.label}
                </span>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DiscoverMobileView;
